module.exports = __webpack_public_path__ + "img/public/SiteIcons/supportIconThree.svg?2a7f91d0";